module.exports = __webpack_public_path__ + "static/media/dice.a7507812.svg";